import RatingAutoForm from "./RatingAutoForm";

export default RatingAutoForm;